export default {
  zh_cn: {
    ActivityList: "活动列表",
    order: "序号",
    ActivityName: "活动名称",
    ParticipantLimit: "人数限制 ",
    Class: "班级",
    StartTime: "开始时间",
    EndTime: "结束时间",
    Module: "模块",
    URL: "URL",
    Status: "状态",
    Actions: "操作",
    report: "报告",
    RestartActivity: "活动重来",
    ActivityTheme: "活动主题",
    ClassName: "班级名称",
    del: "删除",
    duration: "活动时长",
    minute: "分钟",
    GenerateActivity: "生成活动",
    SelectAnActivity: "选择活动",
    AddActivityTitle: "添加活动题目"
  },
  ZH_HK: {
    ActivityList: "活動列表",
    order: "序號",
    ActivityName: "活動名稱",
    ParticipantLimit: "人數限制 ",
    Class: "班級",
    StartTime: "開始時間",
    EndTime: "結束時間",
    Module: "模塊",
    URL: "URL",
    Status: "狀態",
    Actions: "操作",
    report: "報告",
    RestartActivity: "活動重來",
    ActivityTheme: "活動主題",
    ClassName: "班級名稱",
    del: "删除",
    duration: "活動時長",
    minute: "分鐘",
    GenerateActivity: "生成活動",
    SelectAnActivity: "選擇活動",
    AddActivityTitle: "添加活動題目"
  },
  EN: {
    ActivityList: "Activity List",
    order: "Sort",
    ActivityName: "Activity Name",
    ParticipantLimit: " Participant Limit",
    Class: "Class",
    StartTime: "Start Time",
    EndTime: "End Time",
    Module: "Module",
    URL: "URL",
    Status: "Status",
    Actions: "Actions",
    report: "Report",
    RestartActivity: "Restart Activity",
    ActivityTheme: "Activity Theme",
    ClassName: "Class Name",
    del: "Delete",
    duration: "Duration",
    minute: "minute",
    GenerateActivity: "Generate Activity",
    SelectAnActivity: "Select an activity",
    AddActivityTitle: "Add activity title"
  },
  es: {
    ActivityList: "Lista de Actividades",
    order: "Ordenar",
    ActivityName: "Nombre de la Actividad",
    ParticipantLimit: "Límite de Participantes",
    Class: "Clase",
    StartTime: "Hora de Inicio",
    EndTime: "Hora de Finalización",
    Module: "Módulo",
    URL: "URL",
    Status: "Estado",
    Actions: "Acciones",
    report: "Informe",
    RestartActivity: "Reiniciar Actividad",
    ActivityTheme: "Tema de Actividad",
    ClassName: "Nombre de Clase",
    del: "Eliminar",
    duration: "Duración",
    minute: "min",
    GenerateActivity: "Generar Actividad",
    SelectAnActivity: "Seleccionar una actividad",
    AddActivityTitle: "Añadir Título de la Actividad"
  }
};
